import axios from 'axios';
import Metadata from '../helpers/metadata/Metadata';
import miscFunctions from '../helpers/misc-functions';
import serviceUtil from './serviceUtil';

let helpers = {
  createComment: (comment, eventMetadatum, options) => {
    comment.user_id = comment.user ? comment.user.id : comment.user_id;
    delete comment.user;
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API + '/comments?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        comment: comment,
      },
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
  getComment: (comment_id, options) => {
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API + '/comments/' + comment_id + '?current_company=' + localStorage.current_company_id,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        if (options) {
          return response.data;
        }
        else {
          return miscFunctions.mapApiJson(response.data);
        }
      })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
  updateComment: (comment, eventMetadatum, options) => {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'patch',
      url: process.env.REACT_APP_API + '/comments/' + comment.id + '?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        comment: comment,
      },
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      if (options) {
        return response.data;
      }
      else {
        return miscFunctions.mapApiJson(response.data);
      }
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
  deleteComment: (comment_id, eventMetadatum) => {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      data: {
        event_metadatum: eventMetadatum,
      },
      url: process.env.REACT_APP_API + '/comments/' + comment_id + '?current_company=' + localStorage.current_company_id,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
};

export default helpers;
  



// WEBPACK FOOTER //
// ./src/services/commentsService.js